module.exports = __webpack_public_path__ + "img/se-english-digiskills.997f6af4.png";